module.exports = __webpack_public_path__ + "img/exclamation-mark.06ce7333.png";